module.exports = __webpack_public_path__ + "img/shift-week-off-option.95ff0222.webp";